export function getItem (name: string): any {
    const res = localStorage.getItem(name);
    if (res) {
        try {
            return JSON.parse(res);
        } catch (e) {
            return null;
        }
    }
    return res;
}
export function setItem (name: string, value: any): void {
    // This is just a hack to ensure JSON stringified data is in the localstorage
    try {
        JSON.parse(value);
        return localStorage.setItem(name, value);
    } catch (e) {
        return localStorage.setItem(name, JSON.stringify(value));
    }
}
export function removeItem (name: string): void {
    return localStorage.removeItem(name);
}
export function clear (): void {
    return localStorage.clear();
}

export function existsItem (name: string): any {
    return name in localStorage;
}
